import type {UrlStateManagerService} from 'shared/state-manager';
import type {Auth, EditedProperty} from 'src/typings';
import type {DvkStatsData, DvkStatsDataParams, PublicStatsData, PublicStatsDataParams, ZStatsData} from './types';
import type {StatsDataService} from './stats.data-service';
import type {Observable} from 'rxjs';
import {transferify} from 'shared/utils/data-service-utils';

export class StatsService {
    public static serviceName = 'kpStatsService';

    /*@ngInject*/
    constructor(private urlStateManagerService: UrlStateManagerService<PublicStatsDataParams | DvkStatsDataParams>,
                private statsDataService: StatsDataService,
                private currentAuth: Auth) {
    }

    public async loadPublicStatsData(params?: PublicStatsDataParams): Promise<PublicStatsData | null> {
        try {
            return await this.statsDataService.getPublicStats(params);
        } catch {
            return null;
        }
    }

    public async loadPublicStatsFormSettings(): Promise<EditedProperty[] | null> {
        try {
            return await this.statsDataService.getPublicStatsFormSettings();
        } catch {
            return null;
        }
    }

    public async loadDvkStatsData(params?: DvkStatsDataParams): Promise<DvkStatsData> {
        try {
            return await this.statsDataService.getDvkStats(params);
        } catch {
            return null;
        }
    }

    public async loadDvkStatsFormSettings(): Promise<EditedProperty[] | null> {
        try {
            return await this.statsDataService.getDvkStatsFormSettings();
        } catch {
            return null;
        }
    }

    public async loadZStatsData(): Promise<ZStatsData> {
        try {
            return await this.statsDataService.getZStatsData();
        } catch {
            return null;
        }
    }

    public getPublicStatsParamsState(): Observable<PublicStatsDataParams> {
        return this.urlStateManagerService.getState$();
    }

    public getOverallStatsParamsState(): Observable<DvkStatsDataParams> {
        return this.urlStateManagerService.getState$();
    }

    public requestUrlParamsChange(params: PublicStatsDataParams | DvkStatsDataParams) {
        this.urlStateManagerService.requestChangeState(transferify(params));
    }

    public isCurrentUserLibrarian(): boolean {
        return this.currentAuth.evided && this.currentAuth.role.includes('ROLE_LIBRARIAN');
    }
}